export const contentTypes = {
  SET_USER_TYPES: 'SET_USER_TYPES',
  GET_USER_ROLES: 'GET_USER_ROLES',
  SET_USER_ROLES: 'SET_USER_ROLES',
  GET_CIRCUITS: 'GET_CIRCUITS',
  SET_CIRCUITS: 'SET_CIRCUITS',
};

export type IContentState = Readonly<{
  userTypes: Content[];
  userRoles: Content[];
  circuits: Content[];
}>;

export type Content = {
  id: number;
  createdDate: string;
  key: string;
  name: string;
};
